import React, { useState, useEffect } from "react";
import "./BuyGuidePage.css";

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname !== "localhost" ?
    "/api"
  : "http://localhost:5000/api");

const BuyGuidePage = () => {
  const [orderLink, setOrderLink] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Hướng dẫn mua xe | XEVF.VN";

    const fetchSettings = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/settings`);
        const data = await response.json();
        if (data && data.buy_guide_order_link) {
          setOrderLink(data.buy_guide_order_link);
        }
      } catch (error) {
        console.error("Error fetching order link:", error);
      }
    };
    fetchSettings();
  }, []);

  const handleOrderClick = () => {
    if (orderLink) {
      window.open(orderLink, "_blank");
    } else {
      alert("Đang cập nhật hệ thống đặt hàng. Vui lòng liên hệ trực tiếp.");
    }
  };

  const steps = [
    {
      img: "/Buoc1.png",
      title: "Bước 1: Chọn Xe",
      desc: "Chọn dòng xe bạn ưng ý nhất.",
    },
    {
      img: "/Buoc2.png",
      title: "Bước 2: Chọn cấu Hình Xe",
      desc: "Lựa chọn phiên bản, màu xe. Lưu ý giá xe hiển thị chưa bao gồm các khuyến mãi.",
    },
    {
      img: "/Buoc3.png",
      title: "Bước 3: Nhập Thông người mua",
      desc: "Điền đầy đủ thông tin của bạn. Giữ nguyên mã giới thiệu của mình (A001VFSG) để mình hỗ trợ bạn làm hợp đồng và các thủ tục pháp lý: Đăng ký, đăng kiểm, nhận xe.",
    },
    {
      img: "/Buoc4.png",
      title: "Bước 4: Chọn hình thức thanh toán",
      desc: "Chọn hình thức thanh toán như trong hình. Đây là tiền đặt cọc. Bạn sẽ chỉ phải thanh toán toàn bộ tiền mua xe sau khi ký hợp đồng hoặc ngân hàng giải ngân tiền mua xe.",
    },
    {
      img: "/Buoc5.png",
      title: "Bước 5: Tiến hành thanh toán",
      desc: "Bạn ở App ngân hàng, quét mã QR để thanh toán đặt cọc. Mình sẽ liên hệ với bạn để hoàn tất hợp đồng, hướng dẫn đăng ký - đăng kiểm và nhận xe.",
    },
  ];

  return (
    <div className="buy-guide-page">
      <div className="guide-hero">
        <div className="guide-hero-content">
          <h1>HƯỚNG DẪN MUA XE VINFAST ONLINE</h1>
          <p>
            Đây là hướng dẫn đặt hàng trên hệ thống chính thức của VinFast. Nếu
            cần hỗ trợ hãy liên hệ với mình.
          </p>

          <button
            className="btn btn-primary btn-large"
            onClick={handleOrderClick}
          >
            ĐẾN VINFAST ĐẶT XE
          </button>
        </div>
      </div>

      <div className="guide-steps-container">
        {steps.map((step, index) => (
          <div className="guide-step" key={index}>
            <div className="step-image">
              <img src={step.img} alt={step.title} />
              <div className="step-number">{index + 1}</div>
            </div>
            <div className="step-content">
              <h2>{step.title}</h2>
              <p>{step.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="guide-cta-bottom">
        <h2>Bạn đã sẵn sàng?</h2>
        <p>
          Nhấp vào nút bên dưới để bắt đầu đặt xe trên hệ thống chính thức của
          Vinfast.
        </p>
        <button
          className="btn btn-primary btn-large"
          onClick={handleOrderClick}
        >
          ĐẾN VINFAST ĐẶT XE
        </button>
      </div>
    </div>
  );
};

export default BuyGuidePage;
